<template>
  <div>

    <stat-prices></stat-prices>

  </div>
</template>

<script>

  import StatPrices from "./Prices/Index"

  export default {
    name: "Statistics",
    components: {StatPrices},
  }
</script>



// WEBPACK FOOTER //
// resources/assets/js/components/Dashboard/Statistics/Index.vue